// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loader.css */
.loader {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    width: 100%; /* Genişliği %100 yapıyoruz */
    max-width: 400px; /* Maksimum genişlik */
    margin: 0 auto;
    box-sizing: border-box; /* Padding ve border'ın toplam genişliğe dahil edilmesi için */
}

.line {
    width: 37.5%; /* Başlangıç genişliği (%37.5) */
    height: 10px; /* Çizgi kalınlığı */
    background-color: #3c4f58;
    animation: slide 1s infinite ease-in-out;
    border-radius: 10px;
}

.line:nth-child(1) {
    animation-delay: 0s;
}

.line:nth-child(2) {
    animation-delay: 0.2s;
}

.line:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes slide {
    0%, 100% {
        width: 37.5%; /* Başlangıç genişliği */
    }
    50% {
        width: 87.5%; /* Maksimum genişlik (%87.5) */
    }
}

/* Responsive tasarım için medya sorguları */
@media (max-width: 768px) {
    .loader {
        max-width: 300px; /* Orta boyutlu ekranlarda maksimum genişlik */
    }
}

@media (max-width: 480px) {
    .loader {
        max-width: 250px; /* Küçük ekranlarda maksimum genişlik */
    }
    .line {
        height: 8px; /* Çizgi kalınlığını azaltıyoruz */
        border-radius: 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW,EAAE,6BAA6B;IAC1C,gBAAgB,EAAE,sBAAsB;IACxC,cAAc;IACd,sBAAsB,EAAE,8DAA8D;AAC1F;;AAEA;IACI,YAAY,EAAE,gCAAgC;IAC9C,YAAY,EAAE,oBAAoB;IAClC,yBAAyB;IACzB,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,YAAY,EAAE,wBAAwB;IAC1C;IACA;QACI,YAAY,EAAE,8BAA8B;IAChD;AACJ;;AAEA,4CAA4C;AAC5C;IACI;QACI,gBAAgB,EAAE,8CAA8C;IACpE;AACJ;;AAEA;IACI;QACI,gBAAgB,EAAE,uCAAuC;IAC7D;IACA;QACI,WAAW,EAAE,kCAAkC;QAC/C,kBAAkB;IACtB;AACJ","sourcesContent":["/* Loader.css */\r\n.loader {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n    width: 100%; /* Genişliği %100 yapıyoruz */\r\n    max-width: 400px; /* Maksimum genişlik */\r\n    margin: 0 auto;\r\n    box-sizing: border-box; /* Padding ve border'ın toplam genişliğe dahil edilmesi için */\r\n}\r\n\r\n.line {\r\n    width: 37.5%; /* Başlangıç genişliği (%37.5) */\r\n    height: 10px; /* Çizgi kalınlığı */\r\n    background-color: #3c4f58;\r\n    animation: slide 1s infinite ease-in-out;\r\n    border-radius: 10px;\r\n}\r\n\r\n.line:nth-child(1) {\r\n    animation-delay: 0s;\r\n}\r\n\r\n.line:nth-child(2) {\r\n    animation-delay: 0.2s;\r\n}\r\n\r\n.line:nth-child(3) {\r\n    animation-delay: 0.4s;\r\n}\r\n\r\n@keyframes slide {\r\n    0%, 100% {\r\n        width: 37.5%; /* Başlangıç genişliği */\r\n    }\r\n    50% {\r\n        width: 87.5%; /* Maksimum genişlik (%87.5) */\r\n    }\r\n}\r\n\r\n/* Responsive tasarım için medya sorguları */\r\n@media (max-width: 768px) {\r\n    .loader {\r\n        max-width: 300px; /* Orta boyutlu ekranlarda maksimum genişlik */\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .loader {\r\n        max-width: 250px; /* Küçük ekranlarda maksimum genişlik */\r\n    }\r\n    .line {\r\n        height: 8px; /* Çizgi kalınlığını azaltıyoruz */\r\n        border-radius: 8px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
